var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"limage"},[_c('img',{staticClass:"lazyload",attrs:{"src":"data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==","data-src":_vm.browserSrc,"alt":_vm.alt}}),_c('loader',{staticClass:"overlay"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }